/*
    Qué cuenta como mezcla y qué cuenta como chatarra, por zona. Es la copia de
    front de Utils/ClasificacionResiduos.cs del back: las dos tienen que decir lo
    mismo, porque la pantalla calcula sobre las filas visibles y el Excel lo
    recalcula en el servidor.

    Zona 1 (Europa) y zona 3 (Países no GOA) clasifican por código LER, igual que
    siempre. Zona 2 (México) no puede: su catálogo son 11 residuos que comparten
    todos el mismo `codigo` ('1'), así que la única clave estable es `codResiduo`.
    La equivalencia acordada es Pétreos = mezcla y Metales = chatarra; el resto del
    catálogo mexicano cuenta como segregado, el metal incluido.

    La zona 3 se queda a propósito en la rama LER: ninguno de sus residuos tiene
    código LER, así que hoy da 0 de mezcla y seguirá dándolo. No se le inventa aquí
    una equivalencia que nadie ha definido.

    La bifurcación es siempre "=== 2", nunca "!== 1": hay filas sin zona resuelta y
    tienen que seguir cayendo por la rama LER.
*/

export const ZONA_MEXICO = 2;

/* RCD mezclados, mezcla de residuos municipales y voluminosos. */
export const CODIGOS_MEZCLA_LER = ["170904", "200301", "200307"];

export const CODIGOS_CHATARRA_LER = [
    "150104",
    "170401",
    "170402",
    "170405",
    "170407",
    "170411",
    "191202",
    "200140",
];

/* Pétreos. */
export const CODS_RESIDUO_MEZCLA_MEXICO = [1025];

/* Metales. */
export const CODS_RESIDUO_CHATARRA_MEXICO = [1026];

const esZonaMexico = (codZona) => Number(codZona) === ZONA_MEXICO;

const codigoNormalizado = (codigo) => String(codigo ?? "").trim();

export function esMezcla({ codZona, codigo, codResiduo }) {
    return esZonaMexico(codZona)
        ? CODS_RESIDUO_MEZCLA_MEXICO.includes(Number(codResiduo))
        : CODIGOS_MEZCLA_LER.includes(codigoNormalizado(codigo));
}

export function esChatarra({ codZona, codigo, codResiduo }) {
    return esZonaMexico(codZona)
        ? CODS_RESIDUO_CHATARRA_MEXICO.includes(Number(codResiduo))
        : CODIGOS_CHATARRA_LER.includes(codigoNormalizado(codigo));
}
